export default __webpack_public_path__ + "static/media/Ron_Scolesdang.8b3a4302.jpg";